import React from 'react'

export default ({ fill, outline, transparent = true }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.50004 13.5L10.5858 19.5858C11.3669 20.3668 12.6332 20.3668 13.4143 19.5858L19.5 13.5C21.433 11.567 21.433 8.433 19.5 6.5C17.567 4.567 14.433 4.567 12.5 6.5C12.2239 6.77614 11.7762 6.77614 11.5 6.5C9.56704 4.567 6.43304 4.567 4.50004 6.5C2.56704 8.433 2.56705 11.567 4.50004 13.5Z"
        fill={fill}
        fillOpacity={transparent ? '0' : '1'}
        stroke={outline}
      />
    </svg>
  )
}
